import { useEffect, useState } from 'react'
import { gateway, type ConnectionStatus } from '@/lib/gateway'

/** Assina o estado da conexão do gateway, para a faixa de aviso de offline. */
export function useGatewayStatus(): ConnectionStatus {
  const [status, setStatus] = useState<ConnectionStatus>(gateway.currentStatus)

  useEffect(() => gateway.onStatus(setStatus), [])

  return status
}
